// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  travelId: __t.u64().primaryKey().name("travel_id"),
  identity: __t.identity(),
  requestId: __t.string().name("request_id"),
  mode: __t.string(),
  fromSystem: __t.string().name("from_system"),
  toSystem: __t.string().name("to_system"),
  whKey: __t.string().name("wh_key"),
  departAt: __t.timestamp().name("depart_at"),
  arriveAt: __t.timestamp().name("arrive_at"),
  state: __t.string(),
});
